import { projectDataType } from ".";

const modularLandscapesData: projectDataType = {
  path: "modularlandscapes",
  title: "Modular Landscapes",
  coverImage:
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964341/Art-Site/Modular-Landscapes/12028687_10208018435278202_8949771425615476840_o-u9305-fr_tczhlv.png",
  description:
    "A series of ship windows traveling thru an array of landscapes.",
  year: 2016,
  projectPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684964341/Art-Site/Modular-Landscapes/12028687_10208018435278202_8949771425615476840_o-u9305-fr_tczhlv.png",
    "Art-Site/lavastorm.gif",
    "Art-Site/modular-landscapes-daytimefog.gif",
    "Art-Site/dustysky.gif",
  ],
  installPhotos: [
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684540837/Art-Site/Modular-Landscapes/ggrphcllyindtrmntfntss-modulardoc-03_kvwl8l.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684540838/Art-Site/Modular-Landscapes/ggrphcllyindtrmntfntss-modulardoc-02_gltczn.jpg",
    "https://res.cloudinary.com/delu9m4xu/image/upload/v1684540838/Art-Site/Modular-Landscapes/ggrphcllyindtrmntfntss-modulardoc-01_ac5tz8.jpg",
  ],
};

export default modularLandscapesData;
